export default __webpack_public_path__ + "static/media/product-19.70221454.webp";